
import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {getBizList,getCmsList,getCourseList,getOfflineCourseList} from "../../api/service.js"
import $ from 'jquery'
export default{
    components:{
        myHeader,
        myFooter
    },

    data(){
        return {
            BannerList:[],
            noDataShow:true,
            onlineCourse:'',  //在学课程
            studyTimeRankingList:[],
            generalMyNewsList:[],
            headlineMyNewsList:[],
            generalIndustryNewsList:[],
            headlineIndustryNewsList:[],
            catetoryPatentList:[],
            catetoryIndex:0,
            bannerList:[{
              bannerUrl:"",
              bannerPic:"../../../static/enterpriseEdition/1.jpg"
            },{
              bannerUrl:"",
              bannerPic:"../../../static/enterpriseEdition/2.jpg"
            }
            ],

        }
    },
    created(){

    },
    methods:{
      goTy(){
        window.open("http://www.enterprise.eceping.net")
      },
      application(){
        this.$router.push({
          path:"/channelAgent"
        })
      },
      goSaas(){
        this.$router.push({
          path:"/saasHtml"
        })
      },
      goCustomization(){
        this.$router.push({
          path:"/eeHtml"
        })
      },
      goWechat(){
        this.$router.push({
          path:"/weChatHtml"
        })
      }
    }
}



// WEBPACK FOOTER //
// ./src/pages/enterpriseEdition/eHome.js